module.exports = __webpack_public_path__ + "img/20191210162133455.9f2b21e9.jpg";